import React, { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import "./PasswordInput.css";

const PasswordInput = forwardRef(({
  wrapperClassName = "",
  toggleLabel = "password",
  disabled = false,
  ...inputProps
}, ref) => {
  const [visible, setVisible] = useState(false);
  const action = visible ? "Hide" : "Show";

  return (
    <div className={`ui-password-input ${wrapperClassName}`.trim()}>
      <input
        {...inputProps}
        ref={ref}
        type={visible ? "text" : "password"}
        disabled={disabled}
      />
      <button
        type="button"
        className="ui-password-input__toggle"
        aria-label={`${action} ${toggleLabel}`}
        aria-pressed={visible}
        title={`${action} ${toggleLabel}`}
        disabled={disabled}
        onClick={() => setVisible((current) => !current)}
      >
        {visible ? <EyeOff size={20} aria-hidden="true" /> : <Eye size={20} aria-hidden="true" />}
      </button>
    </div>
  );
});

PasswordInput.displayName = "PasswordInput";

export default PasswordInput;
